import { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import "../components/button.css";
import Alerts from "../components/Alerts";
import { TextField, FormControl } from "@mui/material";
import { marginBottom } from "../App";
import Button from "@mui/material/Button";
import architect from "../images/architect.jpg";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { fetchUserData } from "../components/auth";
import { apiRequest } from "../components/Config";

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [apiResponse, setApiResponse] = useState({});
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserDataContext);
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [sent, setSent] = useState(false);

  const ClearApiResponse = () => {
    setShowApiResponse(false);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await apiRequest("login", "POST", {
        user: user,
        password: password,
      });
      setUserData(response);

      const id = response.userId;

      if (response.error_msg === 200 && response.rodo === "1") {
        navigate("/menu");
      }

      if (response.error_msg === 200 && response.rodo === "0") {
        console.log("navi");
        navigate(`/rodo/${id}`);
      }

      if (response.error_msg === 403) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Brak uprawnień lub niewłaściwe hasło!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 501) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Konto nieaktywne, zablokowane lub nie istnieje!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 502) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano nazwy użytkownika.",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 503) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano hasła.",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Błąd podczas wysyłania danych.",
      });
      setShowApiResponse(true);
      navigate("/nopermission");
    }
  };

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const userDataAnswer = await fetchUserData();
        if (userDataAnswer && userDataAnswer.userId) {
          setUserData(userDataAnswer);
          navigate("/menu");
        } else {
          //navigate("/login");
        }
      } catch (error) {
        console.error("Error during user verification:", error);
        //navigate("/login");
      } finally {
        // setLoading(false);
      }
    };
    verifyUser();
  }, [navigate, setUserData]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };
  return (
    <>
      <VN />
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Container>
        <Row>
          <Col>
            <h2>System obsługi zleceń</h2>
            <h1>PZITB</h1>
            <h4>RZECZOZNAWCY</h4>
          </Col>
        </Row>
      </Container>
      <Container>
        <Form onKeyDown={handleKeyDown} autoComplete="off">
          <br></br>
          <Row style={{ marginBottom }}>
            <Col md={2}>
              <ThemeProvider theme={theme}>
                <FormControl fullWidth>
                  <TextField
                    autoComplete="none"
                    label="Konto użytkownika"
                    type="text"
                    variant="outlined"
                    value={user || ""}
                    onChange={(e) => {
                      setUser(e.target.value);
                      ClearApiResponse();
                    }}
                    fullWidth
                  />
                </FormControl>
              </ThemeProvider>
            </Col>
            <Col md={4}></Col>
          </Row>
          <Row style={{ marginBottom }}>
            <Col md={2}>
              <ThemeProvider theme={theme}>
                <FormControl fullWidth>
                  <TextField
                    label="Hasło"
                    type="password"
                    variant="outlined"
                    value={password || ""}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      ClearApiResponse();
                    }}
                    fullWidth
                  />
                </FormControl>
              </ThemeProvider>
            </Col>
            <Col md={4}></Col>

            <Col md={6}>
              Jeśli nie pamiętasz hasła - kliknij tu:{" "}
              <a href="passresetmail">Reset hasła</a>
            </Col>
          </Row>
          <Row style={{ marginBottom }}>
            <Col>
              <ThemeProvider theme={theme}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Zaloguj
                </Button>
              </ThemeProvider>
            </Col>
            <Row style={{ marginBottom }}>
              <img src={architect} alt="architect" />
            </Row>
          </Row>
        </Form>
      </Container>
      <h6>Allworks sp. z o.o. </h6>
    </>
  );
};

export default Login;
